import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { useStyles } from "./styles";

function PrimaryButton({ marginTop, children, ...restProps }) {
  const classes = useStyles();
  const style = { marginTop: `${marginTop}` };

  return (
    <div>
      <Button
        {...restProps}
        variant="contained"
        className={classes.root}
        style={style}
      >
        {children}
      </Button>
    </div>
  );
}

PrimaryButton.propTypes = {
  marginTop: PropTypes.string,
  children: PropTypes.node,
};

export default PrimaryButton;
